import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SubMenus } from './types';
import React from 'react';

const MenuItemLink = ({ item, className }: SubMenus) => {

    const [badgeVisible, setBadgeVisible] = React.useState(false);

    //console.log('item', item);

    const content = (
        <>
            {item.icon && <i className={item.icon}></i>}
            {(item.badge && (!item.badge?.onlyHouver || badgeVisible)) && (
                <span
                    className={classNames('badge', 'bg-' + item.badge.variant, 'rounded', 'font-10', 'float-end', {
                        'text-dark': item.badge.variant === 'light',
                        'text-light': item.badge.variant === 'dark' || item.badge.variant === 'secondary',
                    })}
                >
                    {item.badge.text}
                </span>
            )}
            <span style={{ opacity: item.disable ? 0.6 : 1 }}> {item.label} </span>
        </>
    );

    const commonProps = {
        className: classNames('side-nav-link-ref', 'side-sub-nav-link', className),
        'data-menu-key': item.key,
        onMouseEnter: () => { if (item.badge?.onlyHouver) setBadgeVisible(true); },
        onMouseLeave: () => setBadgeVisible(false)
    };

    return item.url ? (
        <Link
            to={item.url}
            target={item.target}
            {...commonProps}
        >
            {content}
        </Link>
    ) : (
       <a
    href="#"
        className={classNames('side-sub-nav-link', className, 'side-nav-link-ref')}
        data-menu-key={item.key}
        data-ignore-active="true"
        onClick={(e) => e.preventDefault()}
    >
    {content}
    </a>
);
};

export default MenuItemLink;
